import Pagination from 'common/Pagination';
import CancelPop from './CancelPop';
import RescheduleModal from './Reschedule';
import { Row, Table } from 'reactstrap';
import React from 'react';
import BookingAccordionDetails from './BookingDetailsAccordion';
import { GridFilterBar } from 'pages/Partners/PartnersList/components/GridFilterBar';
import NoData from 'common/NoData';
import PageLoader from 'common/PageLoader';
import { FILTERS } from 'pages/Customers/constant';
import { getBookingActions } from 'utils/getBookingActions';
import { useContext } from 'react';
import type { UsersContextProps } from '../../userContextDetail';
import { UsersContextDetail } from '../../userContextDetail';
import BookingTableRow from './BookingTableRow';

interface RenderBookingDetailsProps {
  bookingData: any;
  bookingLoading: boolean;
  bookingError: any;
  bookingStatus: number;
}

const getPopoverTargetId = (index: number, type: string) =>
  `popover-${type}-${index}`;

export const RenderBookingDetails: React.FC<RenderBookingDetailsProps> = ({
  bookingData,
  bookingLoading,
  bookingError,
  bookingStatus,
}) => {
  const {
    showRescheduleModal,
    setShowRescheduleModal,
    rescheduleBooking,
    setRescheduleBooking,
    showCancelPop,
    setShowCancelPop,
    cancelBooking,
    setCancelBooking,
    bookingControlState,
    setBookingControlState,
  } = useContext(UsersContextDetail) as UsersContextProps;

  const rowsPerPage = 10;

  const bookings = bookingData?.bookings || [];

  const totalPages =
    Math.floor(bookings.length / rowsPerPage) +
    (bookings.length % rowsPerPage ? 1 : 0);

  const toggleState = (
    key: keyof typeof bookingControlState,
    value: number | null,
  ) => {
    setBookingControlState((prev) => {
      const newState = {
        openChefPopover: null,
        ellipsisPopover: null,
        openRow: null,
        openPopoverIndex: null,
        currentPage: prev.currentPage,
      };
      return {
        ...newState,
        [key]: prev[key] === value ? null : value,
      };
    });
  };

  const getPaginatedRows = () => {
    const startIndex = (bookingControlState.currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return bookings.slice(startIndex, endIndex);
  };

  if (bookingLoading) return <PageLoader />;
  if (bookingError)
    return <p>Something went wrong while fetching booking details!</p>;
  if (bookingStatus !== 200 || !bookings.length)
    return <NoData customMessage="No Bookings Available." />;

  const handleToggleRow = (index: number, e: React.MouseEvent) => {
    e.stopPropagation();
    toggleState('openRow', index);
  };

  return (
    <>
      <h5 className="mt-2 heading">
        Bookings <span>({bookings.length})</span>
      </h5>
      <GridFilterBar
        filterCriteria={FILTERS}
        searchKeyword=""
        totalCount={bookings.length}
        onSearch={() => {}}
        onClearSearch={() => {}}
      />
      <Row className="table-container mt-3">
        <Table responsive size="sm" striped className="dataTable">  
          <thead>
            <tr>
              <th>Date</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Occasions</th>
              <th>Meal</th>
              <th>Chef</th>
              <th>Address</th>
              <th>Status</th>
              <th>Review</th>
            </tr>
          </thead>
          <tbody>
            
            {getPaginatedRows().map((booking: any, index: number) => (
              <React.Fragment key={booking.id}>
                <BookingTableRow
                  booking={booking}
                  index={index}
                  bookingControlState={bookingControlState}
                  handleToggleRow={handleToggleRow}
                  toggleState={
                    toggleState as (key: string, value: number | null) => void
                  }
                  getPopoverTargetId={getPopoverTargetId}
                  getBookingActions={getBookingActions}
                  setRescheduleBooking={setRescheduleBooking}
                  setShowRescheduleModal={setShowRescheduleModal}
                  setCancelBooking={setCancelBooking}
                  setShowCancelPop={setShowCancelPop}
                />
                {bookingControlState.openRow === index && (
                  <BookingAccordionDetails
                    booking={booking}
                    index={index}
                    state={true}
                    toggleState={() => toggleState('openRow', index)}
                  />
                )}
              </React.Fragment>
            ))}
          </tbody>
        </Table>
      </Row>
      <Pagination
        currentPage={bookingControlState.currentPage}
        totalPages={totalPages}
        onPageChange={(page) => toggleState('currentPage', page)}
      />
      <RescheduleModal
        isOpen={showRescheduleModal}
        onClose={() => {
          setShowRescheduleModal(false);
          setRescheduleBooking(null);
        }}
        initialDate={
          rescheduleBooking?.startDate
            ? new Date(rescheduleBooking.startDate)
            : new Date()
        }
        onConfirm={(newDate: any) => {
          console.log('New Date:', newDate);
        }}
        booking={rescheduleBooking}
      />
      {showCancelPop && cancelBooking && (
        <CancelPop
          isOpen={showCancelPop}
          onClose={() => {
            setShowCancelPop(false);
            setCancelBooking(null);
          }}
          booking={cancelBooking}
        />
      )}
    </>
  );
};
